import { MNSproCloudApi } from '..';
import { ImportReportResponse } from '../api/v2';

const getClassRegisterApi = (authToken: string) =>
  MNSproCloudApi.V2.ClassRegisterApiFactory(
    MNSproCloudApi.V2.createConfiguration(authToken),
  );

class ImportReportService {
  /**
   *
   * @param authToken
   * @param organizationId
   * @returns importReportResponse
   */
  static async getImportReport(
    authToken: string,
    organizationId: string,
  ): Promise<ImportReportResponse> {
    const api = getClassRegisterApi(authToken);
    const importReportResponse = await api.getReport(organizationId);

    return importReportResponse.data;
  }
}

export { ImportReportService };
